import { Row, Col } from "antd";
import Members from "containers/AboutUs/Members/Members";
import PartnersPage from "containers/AboutUs/PartnersPage/PartnersPage";
import { Route, Switch } from "react-router-dom";
import { useViewport } from "@bindeleddet/core/hooks";
import BindeleddetImage from "assets/images/headerImage/BL_fellesbilde_26_27.jpg";
import AboutBindeleddet from "./AboutBindeleddet/AboutBindeleddet";
import HeaderImage from "./HeaderImage/HeaderImage";
import DetailedHistory from "./DetailedHistory/DetailedHistory";
import NavMenu from "./NavMenu/NavMenu";
import Timeline from "./Timeline/Timeline";

const AboutUs = () => {
  const { width } = useViewport();
  const breakpoint = 992;

  return (
    <>
      <HeaderImage imageLink={BindeleddetImage} alt="Bindeleddet members" />
      <Row gutter={[0, 48]} wrap style={{ paddingLeft: "5%", paddingRight: "5%", paddingTop: "90px" }}>
        <Col lg={6} sm={24} xs={24}>
          {/* TODO maybe add affix to navbar so it moves down only on the white */}
          <NavMenu />
        </Col>
        <Col lg={18} sm={24} style={{ paddingLeft: width >= breakpoint ? "5em" : "0%" }}>
          <Switch>
            <Route path="/about-us/members/" component={Members} />
            <Route path="/about-us/history/timeline/" component={Timeline} />
            <Route path="/about-us/history/detailed-history/" component={DetailedHistory} />
            <Route path="/about-us/partners/" component={PartnersPage} />
            <Route path="/about-us/" component={AboutBindeleddet} />
          </Switch>
        </Col>
      </Row>
    </>
  );
};

export default AboutUs;
